/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * File status enumeration.
 */
export enum FileStatus {
    UPLOADING = 'uploading',
    READY = 'ready',
    PROCESSING = 'processing',
    FAILED = 'failed',
    DELETED = 'deleted',
}
